import script from "./doctorPage.vue?vue&type=script&setup=true&lang=js"
export * from "./doctorPage.vue?vue&type=script&setup=true&lang=js"

import "./doctorPage.vue?vue&type=style&index=0&id=dc9e3faa&scoped=true&lang=css"
import "./doctorPage.vue?vue&type=style&index=1&id=dc9e3faa&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dc9e3faa"]])

export default __exports__